import { Toaster } from 'src/common/@the-source/atoms';
import { useSelector } from 'react-redux';
import CustomToast from 'src/common/CustomToast';
import constants from 'src/utils/constants';

const Toast = () => {
	const message = useSelector((state: any) => state.message);
	const toast_renderer_map = {
		[constants.TOAST_TYPES.DEFAULT]: <Toaster {...message} />,
		[constants.TOAST_TYPES.CUSTOM]: <CustomToast {...message} />,
	};
	return message.open && toast_renderer_map[message.toast_type || constants.TOAST_TYPES.DEFAULT];
};

export default Toast;
